import {Button, message, Upload} from 'antd';
import ExcelUtils from '../utils/ExcelUtils';
import React from 'react';
import {ButtonProps} from 'antd/lib/button';
export interface IImportSvcFile extends ButtonProps {
  beforeUpload: (data: any[]) => any;
}
export default function ImportSvcFile(props: IImportSvcFile) {
  function loadExcel(file: File) {
    ExcelUtils.loadExcel(file, (rows: any[]) => {
      props.beforeUpload(rows);
    });
    return false;
  }
  return (
    <Upload showUploadList={false} beforeUpload={loadExcel} customRequest={() => console.log()}>
      <Button type={'primary'} {...props}>
        上传 CCF 缴费记录
      </Button>
    </Upload>
  );
}
